export const CREATIVE_ID_DASHBOARD_LISTINGS = 'dashboard-private-party-listings';
export const PRIVATE_PARTY_THANK_YOU = 'privatePartyThankYou';

export const OTHER = 'other';

export const MODAL_THANK_YOU_BG_HEIGHT = 74;
export const MODAL_BG_HEIGHT = 212;
export const MODAL_MOBILE_BG_HEIGHT = 270;

export const PRIVATE_PARTY_SELL_CAR_CTA = 'List My Car to Sell';
export const WHY_NOT_APPROVED = 'Why was this listing not approved';
export const EDIT_RESUBMIT = 'Edit & Resubmit';
export const MANAGE_MY_LISTING = 'Manage My Listing';

/* TODO: Should be removed when clean up TED-6839-Private-Party-Used-Core-Entry */
export const CREATIVE_ID_ENTRY_PRIVATE_PARTY = 'edm-entry-private-party';
const IMG_SRC_V1 = '/img/car-buying/private-party/icon_coin_falling_into_hand.svg';
const IMG_SRC_V2 = '/img/car-buying/private-party/lady-in-chair-chilling.png';
const IMG_SRC_MOBILE_V2 = '/img/car-buying/private-party/lady-in-chair.png';
const BENEFITS_V1 = [
  'Make more selling privately',
  `<strong>FREE</strong> sharable listing URL`,
  'Get paid securely with Caramel',
];
const BENEFITS_V2 = [
  `<strong>Get more for your car</strong> by selling to private buyers`,
  `Share your <strong>free listing URL</strong> anywhere you'd like`,
  'Secure payment and paperwork with Caramel',
];
export const PRIVATE_PARTY_SELL_CAR_TED6839 = {
  'chal-1': {
    header: 'Create Your Free Car \nListing with Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
  'chal-2': {
    header: 'List Your Car with Edmunds. It’s Easy!',
    headerMobile: 'List Your Car with Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
  'chal-3': {
    header: 'Sell Your Car on Edmunds. It’s Easy!',
    headerMobile: 'Sell Your Car on Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
  'chal-4': {
    header: `Create Your <span class="text-blue-50">Free</span> Car \nListing with Edmunds`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
  'chal-5': {
    header: `List Your Car with \nEdmunds. <span class="text-blue-50">It’s Easy!</span>`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
  'chal-6': {
    header: `Sell Your Car on \nEdmunds. <span class="text-blue-50">It’s Easy!</span>`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
};

export const PRIVATE_PARTY_SELL_CAR_TED6883 = {
  'chal-1': {
    header: `Create Your <span class="text-blue-50">Free</span> Car \nListing with Edmunds`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
  'chal-2': {
    header: `List Your Car with \nEdmunds. <span class="text-blue-50">It’s Easy!</span>`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
  'chal-3': {
    header: `Sell Your Car on \nEdmunds. <span class="text-blue-50">It’s Easy!</span>`,
    benefits: BENEFITS_V2,
    imageSrc: IMG_SRC_V2,
    imageSrcMobile: IMG_SRC_MOBILE_V2,
  },
  'chal-4': {
    header: 'Create Your Free Car \nListing with Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
  'chal-5': {
    header: 'List Your Car with Edmunds. It’s Easy!',
    headerMobile: 'List Your Car with Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
  'chal-6': {
    header: 'Sell Your Car on Edmunds. It’s Easy!',
    headerMobile: 'Sell Your Car on Edmunds',
    imageSrc: IMG_SRC_V1,
    benefits: BENEFITS_V1,
  },
};
